import { render, staticRenderFns } from "./GTopicFormForTrendAnalysis.vue?vue&type=template&id=22afb4a0&scoped=true&"
import script from "./GTopicFormForTrendAnalysis.vue?vue&type=script&lang=ts&"
export * from "./GTopicFormForTrendAnalysis.vue?vue&type=script&lang=ts&"
import style0 from "./GTopicFormForTrendAnalysis.vue?vue&type=style&index=0&id=22afb4a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22afb4a0",
  null
  
)

export default component.exports